import { StatusOption } from '../../utils'

export enum PriorityEnum {
  NORMAL = 'NORMAL',
  PRIMARY = 'PRIMARY',
  URGENT = 'URGENT'
}
export const priorityEnumMapping: Record<PriorityEnum, StatusOption> = {
  NORMAL: {
    label: 'Normale',
    variant: 'success'
  },
  PRIMARY: {
    label: 'Prioritaire',
    variant: 'warning'
  },
  URGENT: {
    label: 'Urgente',
    variant: 'danger'
  }
}
